import { createFileRoute } from '@tanstack/react-router'
import { DutiesPage } from '~/features/operations/DutiesPage'
import { dutiesRange } from '~/features/operations/search'
import { dutiesQuery } from '~/features/operations/queries'
import { Gate, RouteError } from '~/features/operations/shared'
import { mayRead } from '~/features/org/guard'

type Search = { zeitraum?: 'vergangen' }

export const Route = createFileRoute('/_app/verein/betrieb/dienste')({
  validateSearch: (s: Record<string, unknown>): Search => (s.zeitraum === 'vergangen' ? { zeitraum: 'vergangen' } : {}),
  loaderDeps: ({ search }) => ({ past: search.zeitraum === 'vergangen' }),
  loader: async ({ context, deps }) => {
    if (!(await mayRead(context.queryClient, 'ops.read'))) return
    const r = await dutiesRange(context.queryClient, deps.past)
    await context.queryClient.ensureQueryData(dutiesQuery(r.from, r.to, r.order))
  },
  component: () => (
    <Gate permission="ops.read">
      <DutiesPage />
    </Gate>
  ),
  errorComponent: RouteError,
})
